import React from 'react';
import './UniversityPage.css';

const UniversityPage6 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>University of Bari Aldo Moro</h1>
                    <h2>Medicine and Surgery Program</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>The University of Bari Aldo Moro offers a globally recognized <strong>Medicine and Surgery</strong> program taught entirely in English. The program follows a six-year curriculum designed to train competent medical professionals with a strong foundation in theoretical knowledge and practical skills. As one of Italy's prestigious medical schools, Bari attracts students from all over the world due to its affordable tuition fees, high-quality education, and vibrant student life.</p>
                    <a href="https://www.uniba.it/it/corsi/medicina-chirurgia-bemc">Learn More</a>
                </section>

                <section className="ranking">
                    <h2>International Ranking</h2>
                    <p>The University of Bari is ranked among the top public universities in Italy. While it may not always feature in the top global medical university rankings, it holds a strong position in national and European rankings for its research output and quality of education. The university is known for its cutting-edge medical research and well-structured programs, making it a competitive choice for international students.</p>
                </section>

                <section className="seats-available">
                    <h2>Seats Available for EU and Non-EU Students</h2>
                    <p>Each year, the University of Bari offers a limited number of seats for its <strong>Medicine and Surgery</strong> program. The typical seat distribution is as follows:</p>
                    <ul>
                        <li><strong>EU Students:</strong> 69 seats</li>
                        <li><strong>Non-EU Students:</strong> 8 + 3 Marcopolo seats</li>
                    </ul>
                    <p>These numbers may vary slightly each year based on government regulations and university policies.</p>
                </section>

                <section className="imat-scores">
                    <h2>IMAT Cut-Offs for the Past 5 Years</h2>
                    <p>The <strong>International Medical Admissions Test (IMAT)</strong> is the entrance exam required for admission. The cut-off scores vary each year based on applicant performance and seat availability. Below is a table of the IMAT cut-offs for the University of Bari:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>EU First Cut-Off</th>
                                    <th>EU Last Cut-Off</th>
                                    <th>Non-EU Cut-Off</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2024</td>
                                    <td>59.1</td>
                                    <td>--</td>
                                    <td>65.8</td>
                                </tr>
                                <tr>
                                    <td>2023</td>
                                    <td>36.2</td>
                                    <td>34.1</td>
                                    <td>31.2</td>
                                </tr>
                                <tr>
                                    <td>2022</td>
                                    <td>43.3</td>
                                    <td>34.5</td>
                                    <td>44.1</td>
                                </tr>
                                <tr>
                                    <td>2021</td>
                                    <td>43.3</td>
                                    <td>33.9</td>
                                    <td>32.7</td>
                                </tr>
                                <tr>
                                    <td>2020</td>
                                    <td>51.0</td>
                                    <td>39.6</td>
                                    <td>41.4</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="admission">
                    <h2>Admission Requirements</h2>
                    <p>To apply for the Medicine and Surgery program at the University of Bari, students must meet the following requirements:</p>
                    <ul>
                        <li><strong>IMAT Exam:</strong> A mandatory entrance test for all applicants.</li>
                        <li><strong>High School Diploma:</strong> Equivalent to the Italian secondary school diploma.</li>
                        <li><strong>Biology, Chemistry, Physics, and Mathematics:</strong> Strong academic background in these subjects.</li>
                        <li><strong>English Proficiency:</strong> Required for non-native English speakers (some exemptions apply).</li>
                    </ul>
                </section>

                <section className="course-structure">
                    <h2>Curriculum Breakdown</h2>
                    <p>The <strong>six-year curriculum</strong> at the University of Bari is structured as follows:</p>

                    <h3>Year 1</h3>
                    <ul>
                        <li>Applied & Molecular Biology (9 CFU)</li>
                        <li>Biochemistry (8 CFU)</li>
                        <li>Chemistry & Propedeutic Biochemistry (6 CFU)</li>
                        <li>Computer, Linguistics & Professional Skills (8 CFU)</li>
                        <li>Human Histology & Embryology (9 CFU)</li>
                        <li>Medical Physics & Medical Statistics (11 CFU)</li>
                        <li>ADE (4 CFU)</li>
                    </ul>

                    <h3>Year 2</h3>
                    <ul>
                        <li>Clinical Methodology (10 CFU)</li>
                        <li>Human Anatomy I & II (10 + 6 CFU)</li>
                        <li>Human Physiology Part I (9 CFU)</li>
                        <li>Human Sciences (4 CFU)</li>
                        <li>Microbiology, Clinical Microbiology & Parasitology (7 CFU)</li>
                        <li>Pathology & General Pathophysiology P.I. (6 CFU)</li>
                        <li>ADE 2 (4 CFU)</li>
                    </ul>

                    <h3>Year 3</h3>
                    <ul>
                        <li>Anatomo Pathology Part 1.A (8 CFU)</li>
                        <li>Cardiovascular & Thoracic Diseases (14 CFU)</li>
                        <li>Human Physiology (7 CFU)</li>
                        <li>Pathology & General Pathophysiology (6 CFU)</li>
                        <li>Sense Organs Clinical Medicine & Surgery (7 CFU)</li>
                        <li>Surgical & Medical Systemic Pathologies 1 (8 CFU)</li>
                        <li>III Year Internship (11 CFU)</li>
                    </ul>

                    <h3>Year 4</h3>
                    <ul>
                        <li>Anatomo Pathology (4 CFU)</li>
                        <li>Diagnostic Imaging (6 CFU)</li>
                        <li>Laboratory Medicine & Genetics (11 CFU)</li>
                        <li>Neurological Science & Rehabilitation (7 CFU)</li>
                        <li>Pharmacology (3 + 6 CFU)</li>
                        <li>Surgical & Medical Systemic Pathologies 2 (8 CFU)</li>
                        <li>IV Year Internship (8 CFU)</li>
                    </ul>

                    <h3>Year 5</h3>
                    <ul>
                        <li>Gynecology & Obstetrics (6 CFU)</li>
                        <li>Muscular Skeletal Diseases (6 CFU)</li>
                        <li>Pediatrics Science (6 CFU)</li>
                        <li>Psychiatry, Psychology & Child Neuropsychiatry (9 CFU)</li>
                        <li>Public Health (15 CFU)</li>
                        <li>Surgical & Medical Systemic Pathologies 3 (10 CFU)</li>
                        <li>V Year Internship (13 CFU)</li>
                    </ul>

                    <h3>Year 6</h3>
                    <ul>
                        <li>Clinical Medicine & Geriatrics (7 CFU)</li>
                        <li>Clinical Surgery (6 CFU)</li>
                        <li>Medical Surgical Emergencies (9 CFU)</li>
                        <li>CFU for Thesis Preparation (9 + 9 CFU)</li>
                        <li>Practical Traineeship (15 CFU)</li>
                        <li>VI Year Internship (15 CFU)</li>
                    </ul>
                </section>

                <section className="exams">
                    <h2>Exams</h2>
                    <p>Students must pass written and oral exams at the end of each module. Clinical skills are also assessed through Objective Structured Clinical Examinations (OSCEs) and practical rotations. The final year includes a thesis defense and a final clinical assessment.</p>
                    <p>Each exam is worth 30 marks, with the minimum passing grade being 18 and the highest being 30 cum laude. Upon passing, you receive a certain number of ECTS credits, which are assigned to each subject. For example, in Medicine and Surgery, you will earn 360 ECTS credits, with 60 credits allocated for each academic year.</p>
                    <p>To take an exam, you must first book it through ESSE3. After completing the exam, you have the option to accept or reject your score.</p>
                </section>

                <section className="scholarships">
                    <h2>Tuition Fees and Scholarships</h2>
                    <p><strong>Tuition Fees:</strong> Range from <strong>€156 to €2200 per year</strong>, depending on family income (ISEE declaration).</p>
                    <p>Tuition fees at the University of Bari vary based on financial circumstances, with reductions available through the ISEE system. This government tool assesses a student's financial status for benefits, including lower tuition rates. Scholarships are available for both merit and need-based students, including programs like Invest Your Talent in Italy for international applicants. These financial aid options help reduce tuition and living costs, making studying in Bari more accessible.</p>
                    <p><strong>Scholarships:</strong> Offered through <strong>ADISU Puglia</strong>, covering tuition, housing, and living expenses for eligible students.</p>
                    <a href="https://adisupuglia.it/pagina116395_portale-studenti.html">ADISU Puglia Scholarships</a>
                </section>

                <section className="international-life">
                    <h2>International Life in Bari</h2>
                    <p>Bari offers a vibrant and welcoming environment for international students, with a strong multicultural community and plenty of opportunities for engagement. The University of Bari provides dedicated support, including language courses, mentorship programs, and student associations to help international students adapt and thrive. Medical students can join AEMSA, the Association of Medical Students of Bari, which organizes academic workshops, networking events, and volunteer projects. The university also boasts excellent facilities, including libraries, study spaces, and sports centers with gyms, swimming pools, and courts. Beyond academics, Bari's lively social scene includes cultural festivals, concerts, and a variety of cafes and restaurants where students can connect. With its blend of academic resources, extracurricular activities, and cultural experiences, international life in Bari is both enriching and dynamic.</p>
                </section>

                <section className="city-info">
                    <h2>Bari as a City</h2>
                    <p>Bari is a charming coastal city in Southern Italy, blending historical heritage with modern urban life. Known for its picturesque old town, stunning Adriatic coastline, and delicious local cuisine, the city provides an inviting atmosphere for students and visitors alike. Bari's bustling port, lively piazzas, and rich cultural scene make it a dynamic place to live and study. The city offers a perfect mix of history, nature, and entertainment, with historic landmarks, scenic promenades, and a vibrant nightlife. Whether exploring ancient streets, relaxing by the sea, or enjoying authentic Italian dishes, Bari provides an enriching and unforgettable experience.</p>
                </section>

                <section className="living-expenses">
                    <h2>Expenses in Bari</h2>
                    <p>The cost of living in Bari is affordable compared to other Italian cities. Estimated monthly expenses:</p>
                    <ul>
                        <li><strong>Accommodation:</strong> €250-€500 (shared/private apartment)</li>
                        <li><strong>Food:</strong> €150-€250</li>
                        <li><strong>Transport:</strong> €25-€40</li>
                        <li><strong>Miscellaneous:</strong> €100-€200</li>
                    </ul>
                    <p>Total estimated living cost: <strong>€500-€1,000 per month</strong>. Your monthly expenses ultimately depend on your lifestyle and spending habits. The estimated amount provided is just an approximation and can vary from person to person. You may end up spending less or more based on your choices and financial management.</p>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>The University of Bari provides an excellent opportunity for students seeking a high-quality medical education in Italy. With its affordable tuition, competitive admission process, and strong academic structure, it is an attractive choice for both EU and non-EU students. The city of Bari further enhances the experience with its welcoming atmosphere and rich cultural heritage, making it a great place to study and live.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage6;